import { useMemo } from "react";

import { useUser } from "@framework/provider-user";
import { IUser } from "@framework/types";

import {
  getDefaultAlarmColor,
  mergeAlarmColors,
  resolveAlarmColorFromPalette,
  type IUserAlarmColors,
} from "../utils/alarm-colors";

export function useAlarmPaletteResolver(): (status: number) => string {
  const user = useUser<IUser>();

  return useMemo(() => {
    const s = user.profile?.interfaceSettings;
    if (!s || s.useDefaultAlarmColors !== false) {
      return getDefaultAlarmColor;
    }
    const merged = mergeAlarmColors(s.alarmColors as Partial<IUserAlarmColors>);
    return (status: number) => resolveAlarmColorFromPalette(status, merged);
  }, [user.profile?.interfaceSettings?.useDefaultAlarmColors, user.profile?.interfaceSettings?.alarmColors]);
}

export function useAlarmColor(status: number): string {
  const resolve = useAlarmPaletteResolver();
  return useMemo(() => resolve(status), [resolve, status]);
}
